import snackbar from "./snackbar"
import articles from "./basedata/articles"
import customers from "./basedata/customers"
import resources from "./basedata/resources"
import projects from "./planningObjects/projects"
import timelines from "./timelines"

export default [...snackbar, ...articles, ...customers, ...resources, ...projects, ...timelines]
